import { CHANGE_EFFECTIVE_DATE, PRICE_LOAD, PRICE_LOAD_FAIL, PRICE_LOAD_SUCCESS } from '../../actions/action-types';
import { Price } from '../../models/price';
import { PriceState } from '../../types/state/price';
import makeErrorSerialisable from '../../utils/make-error-serialisable';

type PriceData = PriceState['data'];
type PriceLoadAction = {
  type: typeof PRICE_LOAD;
};
type PriceLoadSuccessAction = {
  type: typeof PRICE_LOAD_SUCCESS;
  keys: readonly (keyof PriceData)[];
  result: readonly Price[];
};
type PriceLoadFailAction = {
  type: typeof PRICE_LOAD_FAIL;
  error: Parameters<typeof makeErrorSerialisable>[0];
};
type ChangeEffectiveDateAction = {
  type: typeof CHANGE_EFFECTIVE_DATE;
  useFutureEffectiveDate: boolean;
};
type PriceAction = PriceLoadAction | PriceLoadSuccessAction | PriceLoadFailAction | ChangeEffectiveDateAction;

const initialState: PriceState = {
  data: {},
  loading: false,
  useFutureEffectiveDate: false,
};

export default function priceReducer(
  state: PriceState = initialState,
  action: PriceAction = {} as PriceAction,
): PriceState {
  switch (action.type) {
    case PRICE_LOAD:
      return {
        ...state,
        loading: true,
      };
    case PRICE_LOAD_SUCCESS: {
      const { keys, result: prices } = action;
      const mappedKeys = Array.from(keys ?? []).reduce<PriceData>(
        (previous, current, index) => ({
          ...previous,
          [current]: prices[index]!,
        }),
        {},
      );
      return {
        ...state,
        data: {
          ...state.data,
          ...mappedKeys,
        },
        error: null,
        loading: false,
      };
    }
    case PRICE_LOAD_FAIL:
      return {
        ...state,
        error: makeErrorSerialisable(action.error),
        loading: false,
      };
    case CHANGE_EFFECTIVE_DATE:
      return {
        ...state,
        loading: false,
        useFutureEffectiveDate: action.useFutureEffectiveDate,
      };
    default:
      return state;
  }
}
